module.exports = __webpack_public_path__ + "img/AS-12A.e940f2de.jpg";